function StatCard({ label, value, className = "" }) {
  return (
    <div className="border border-black bg-white p-4">
      <div className="overline text-zinc-500 text-[10px]">{label}</div>
      <div className={`font-mono text-3xl font-black mt-1 ${className}`}>{value}</div>
    </div>
  );
}

export default function BackupStatsGrid({ totals }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-testid="backup-stats">
      <StatCard label="Total registros" value={totals.total} />
      <StatCard label="Sucessos" value={totals.success} className="text-[#00A300]" />
      <StatCard label="Parciais" value={totals.partial} className="text-yellow-600" />
      <StatCard label="Falhas" value={totals.failed} className="text-[#E60000]" />
    </div>
  );
}
